import React, { HTMLAttributes } from "react";

type SectionProps = {
  fluid?: boolean;
};

class Section extends React.PureComponent<
  HTMLAttributes<HTMLDivElement> & SectionProps
> {
  static Header: React.FC<{
    className?: string;
  }> = ({ children, className, ...rest }) => {
    const classes = ["header", className].filter(c => !!c).join(" ");
    return (
      <h4 className={classes} {...rest}>
        {children}
      </h4>
    );
  };

  static Content: React.FC = ({ children }) => {
    return <div className="content">{children}</div>;
  };

  render() {
    const { children, className, fluid, ...rest } = this.props;
    const classes = ["section", className, fluid && "fluid"]
      .filter(c => !!c)
      .join(" ");
    return (
      <div className={classes} {...rest}>
        {children}
      </div>
    );
  }
}
export { Section };
